import React, { useState, useEffect, useRef } from "react";
import Papa from "papaparse";
import Chart from "chart.js/auto";
import SubscriptionHeader from "../components/managesubs/SubscriptionHeader";
import { fetchStats, fetchFilteredData } from "./../api/realstate/realstate";
import { useNavigate } from 'react-router-dom';
import { getSubscription } from '../api/stripe/stripe'
import { useAuth } from "../context/Authcontext";

function DataStatsPage() {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  // const [loading, setLoading] = useState(false);
  // const [fileName, setFileName] = useState(""); // To store the CSV file name
  const cityChartRef = useRef(null);
  // const topAgentsChartRef = useRef(null); // Restored Top 5 Agents
  // const loanChartRef = useRef(null);
  // const priceRangeChartRef = useRef(null);
  // const taxAssessedValueChartRef = useRef(null); // Replaced Estates by Price Change
  const cityChartInstance = useRef(null);
  const topAgentsChartInstance = useRef(null);
  const loanChartInstance = useRef(null);
  const priceRangeChartInstance = useRef(null);
  const taxAssessedValueChartInstance = useRef(null);
  // const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchColumn, setSearchColumn] = useState("");
  const [priceRange, setPriceRange] = useState({ min: 10000, max: 1000000 });
  const [paginationRange, setPaginationRange] = useState({ min: 1, max: 50 });
  const [interestRange, setInterestRange] = useState({ min: 0, max: 0.1 });
  const [equityRange, setEquityRange] = useState({ min: 0, max: 1 });
  // const [pgaptFilter, setPgaptFilter] = useState("Clear");
  const [loanTypeFilter, setLoanTypeFilter] = useState([]);
  const [showPriceDropdown, setShowPriceDropdown] = useState(false);
  const [showPaginationDropdown, setShowPaginationDropdown] = useState(false);
  const [showAdvancedDropdown, setShowAdvancedDropdown] = useState(false);
  const [maxPage, setMaxPage] = useState(50);
  const [isClearLoanFilter, setIsClearLoanFilter] = useState(true);
  const [propertiesTypeFilter, setPropertiesTypeFilter] = useState([]);
  const [propertiesFilter, setPropertiesFilter] = useState({});
  const [hasEmail, setHasEmail] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  // const [nullData,setNullData]=useState("");
  const priceDropdownRef = useRef(null);
  const paginationDropdownRef = useRef(null);
  const advancedDropdownRef = useRef(null);
  const priceLimits = { min: 10000, max: 10000000, step: 10000 };
  const paginationLimits = { min: 1, max: 50, step: 1 };
  const interestLimits = { min: 0, max: 0.20, step: 0.001 };
  const equityLimits = { min: 0, max: 1, step: 0.01 };
  const [PropertyTypes, setPropertyTypes] = useState(['MULTI_FAMILY', 'SINGLE_FAMILY', 'TOWNHOUSE'])
  const [displayColumn, setdisplayColumn] = useState(["addressCity", "addressState",])
  const [isMounted, setIsMonthed] = useState(false);
  const { user } = useAuth();


  const handlePriceChange = (type, value) => {
    const numValue = Number(value);
    setPriceRange((prev) => {
      if (type === "min") {
        return { min: Math.min(numValue, prev.max - priceLimits.step), max: prev.max };
      } else {
        return { min: prev.min, max: Math.max(numValue, prev.min + priceLimits.step) };
      }
    });

    // setCurrentPage(1);
  };
  const handlePaginationChange = (type, value) => {
    const numValue = Number(value);
    setPaginationRange((prev) => {
      if (type === "min") {
        return { min: Math.min(numValue, prev.max - paginationLimits.step), max: prev.max };
      } else {
        return { min: prev.min, max: Math.max(numValue, prev.min + paginationLimits.step) };
      }
    });
  }


  const handleInterestChange = (type, value) => {
    const numValue = Number(value);
    setInterestRange((prev) => {
      if (type === "min") {
        return { min: Math.min(numValue, prev.max - interestLimits.step), max: prev.max };
      } else {
        return { min: prev.min, max: Math.max(numValue, prev.min + interestLimits.step) };
      }
    });
    // setCurrentPage(1);
  };

  const handleEquityChange = (type, value) => {
    const numValue = Number(value);
    setEquityRange((prev) => {
      if (type === "min") {
        return { min: Math.min(numValue, prev.max - equityLimits.step), max: prev.max };
      } else {
        return { min: prev.min, max: Math.max(numValue, prev.min + equityLimits.step) };
      }
    });
    // setCurrentPage(1);
  };
  const resetPriceRange = () => {
    setPriceRange({ min: priceLimits.min, max: priceLimits.max });
    // setCurrentPage(1);
  };

  // Reset advanced options
  const resetAdvancedOptions = () => {
    setInterestRange({ min: interestLimits.min, max: interestLimits.max });
    setPropertiesTypeFilter([]);
    setLoanTypeFilter([]);
    setEquityRange({ min: equityLimits.min, max: equityLimits.max });
    setHasEmail(false);
    // setCurrentPage(1);
  };
  const formatPrice = (value) => {
    if (value >= 1000000) return `$${value / 1000000}M`;
    return `$${value / 1000}K`;
  };
  const handleLoanTypeChange = (e) => {

    const value = e.target.value;
    setLoanTypeFilter((prev) =>
      prev.includes(value)
        ? prev.filter((item) => item !== value)
        : [...prev, value]
    );
    setIsClearLoanFilter(false);
    // setLoanTypeFilter(e.target.value);
    // setCurrentPage(1);
  };
  const handlepropertiesTypeFilterChange = async (e) => {
    const value = e.target.value;
    await setPropertiesTypeFilter((prev) =>
      prev.includes(value)
        ? prev.filter((item) => item !== value)
        : [...prev, value]
    );
    console.log(propertiesTypeFilter);
  }
  const formatInterestRate = (value) => `${(value * 100).toFixed(1)}%`;

  const handleColumnChange = (e) => {
    if (e.target.value === "All") {
      setSearchColumn("");
    } else {
      setSearchColumn(e.target.value);
    };
    // setCurrentPage(1);
  };
  // const handlePgaptChange = (e) => {
  //   setPgaptFilter(e.target.value);
  //   // setCurrentPage(1);
  // };
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    // setCurrentPage(1);
  };
  // const handleFileUpload = (event) => {
  //   const file = event.target.files[0];
  //   if (!file || !file.name.endsWith(".csv")) {
  //     setError("Please upload a valid CSV file.");
  //     setFileName("")
  //     return;
  //   }
  //   setLoading(true);
  //   setError("");
  //   setData([]);
  //   setFileName(file.name.replace(".csv", "")); // Extract state name from file name
  //   Papa.parse(file, {
  //     header: true,
  //     skipEmptyLines: true,
  //     complete: (result) => {
  //       if (result.errors.length) {
  //         setError("Error parsing CSV file. Please check the file format.");
  //       } else {
  //         const normalizedData = result.data.map((row) =>
  //           Object.fromEntries(Object.entries(row).map(([key, value]) => [key.trim(), value || "-"]))
  //         );
  //         setData(normalizedData);
  //       }
  //       setLoading(false);
  //     },
  //     error: () => {
  //       setError("Failed to read the CSV file.");
  //       setLoading(false);
  //     },
  //   });
  // };

  const handleExportCSV = async () => {
    setDataLoading(true);
    propertiesFilter.Leads = paginationRange.max;
    const dataFiltered = await fetchFilteredData(propertiesFilter);
    const csv = Papa.unparse(dataFiltered);
    const timestamp = new Date().toISOString().replace(/[:.]/g, "-");
    const defaultFilename = `leads_${timestamp}.csv`;

    if (window.showSaveFilePicker) {
      try {
        const fileHandle = await window.showSaveFilePicker({
          suggestedName: defaultFilename,
          types: [{ description: "CSV Files", accept: { "text/csv": [".csv"] } }],
        });
        const writable = await fileHandle.createWritable();
        await writable.write(csv);
        await writable.close();
      } catch (err) {
        const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", defaultFilename);
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    } else {
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", defaultFilename);
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
    setDataLoading(false);
  };
  const checksubscription = async () => {
    const subscription = await getSubscription();
    console.log(user);
    if (subscription?.status === 404 && user.role !== "admin") {
      navigate('/manage-subscription', { replace: true });
    } else {
      if (subscription.planType === "ent" || subscription.planType === 'one' || user.role === "admin") {
        setdisplayColumn(["addressCity",
          "addressState", "Key words"])
      } else {
        setPropertyTypes([['SINGLE_FAMILY']])
      }
    }
  }
  // Calculate prices and stats
  // const prices = data
  //   .map((row) => parseFloat(row.price?.replace(/[$,]/g, "") || row["hdpData.homeInfo.price"]?.replace(/[$,]/g, "") || 0))
  //   .filter((v) => !isNaN(v));
  // const avgPrice = prices.length ? (prices.reduce((a, b) => a + b, 0) / prices.length).toFixed(2) : 0;

  useEffect(() => {
    if (!isMounted) {
      checksubscription();
      setIsMonthed(true);
    }
    // hadnleSearchStats();
    if (data.totalCount === 0) return;

    // Destroy existing charts to prevent memory leaks
    [cityChartInstance, topAgentsChartInstance, loanChartInstance, priceRangeChartInstance, taxAssessedValueChartInstance].forEach((instance) => {
      if (instance.current) instance.current.destroy();
    });

    // City Chart (Bar) - Wider and taller
    const cityData = data.cities
    if (cityChartRef.current) {
      cityChartInstance.current = new Chart(cityChartRef.current, {
        type: "bar",
        data: {
          labels: Object.keys(cityData),
          datasets: [{
            label: "Estates per City",
            data: Object.values(cityData),
            backgroundColor: "rgba(59, 130, 246, 0.6)",
            borderColor: "rgba(59, 130, 246, 1)",
            borderWidth: 1,
          }],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: { y: { beginAtZero: true, title: { display: true, text: "Number of Estates" } } },
          plugins: { legend: { position: "top" } },
        },
      });
    }

    // const loanData = data.reduce((acc, row) => {
    //   const loan = row["propstream_data.loan_types"] || "Unknown";
    //   acc[loan] = (acc[loan] || 0) + 1;
    //   return acc;
    // }, {});
    // if (loanChartRef.current) {
    //   loanChartInstance.current = new Chart(loanChartRef.current, {
    //     type: "pie",
    //     data: {
    //       labels: Object.keys(loanData),
    //       datasets: [{
    //         data: Object.values(loanData),
    //         backgroundColor: [
    //           "rgba(59, 130, 246, 0.6)",
    //           "rgba(34, 197, 94, 0.6)",
    //           "rgba(234, 179, 8, 0.6)",
    //           "rgba(239, 68, 68, 0.6)",
    //         ],
    //         borderWidth: 1,
    //       }],
    //     },
    //     options: {
    //       responsive: true,
    //       maintainAspectRatio: false,
    //       plugins: { legend: { position: "right" } },
    //     },
    //   });
    // }
    // const priceRanges = {
    //   "<$100K": prices.filter(p => p < 100000).length,
    //   "$100K-$500K": prices.filter(p => p >= 100000 && p < 500000).length,
    //   "$500K-$1M": prices.filter(p => p >= 500000 && p < 1000000).length,
    //   ">=$1M": prices.filter(p => p >= 1000000).length,
    // };
    // if (priceRangeChartRef.current) {
    //   priceRangeChartInstance.current = new Chart(priceRangeChartRef.current, {
    //     type: "bar",
    //     data: {
    //       labels: Object.keys(priceRanges),
    //       datasets: [{
    //         label: "Estates by Price Range",
    //         data: Object.values(priceRanges),
    //         backgroundColor: "rgba(234, 179, 8, 0.6)",
    //         borderColor: "rgba(234, 179, 8, 1)",
    //         borderWidth: 1,
    //       }],
    //     },
    //     options: {
    //       responsive: true,
    //       maintainAspectRatio: false,
    //       scales: { y: { beginAtZero: true, title: { display: true, text: "Number of Estates" } } },
    //       plugins: { legend: { position: "top" } },
    //     },
    //   });
    // }

    // // Estates by Tax Assessed Value Range (Bar) - Replaced Estates by Price Change
    // const taxAssessedValues = data
    //   .map((row) => parseFloat(row["hdpData.homeInfo.taxAssessedValue"]?.replace(/[$,]/g, "") || 0))
    //   .filter((v) => !isNaN(v));
    // const taxAssessedValueRanges = {
    //   "<$200K": taxAssessedValues.filter(v => v < 200000).length,
    //   "$200K-$500K": taxAssessedValues.filter(v => v >= 200000 && v < 500000).length,
    //   "$500K-$1M": taxAssessedValues.filter(v => v >= 500000 && v < 1000000).length,
    //   ">=$1M": taxAssessedValues.filter(v => v >= 1000000).length,
    // };
    // if (taxAssessedValueChartRef.current) {
    //   taxAssessedValueChartInstance.current = new Chart(taxAssessedValueChartRef.current, {
    //     type: "bar",
    //     data: {
    //       labels: Object.keys(taxAssessedValueRanges),
    //       datasets: [{
    //         label: "Estates by Tax Assessed Value",
    //         data: Object.values(taxAssessedValueRanges),
    //         backgroundColor: "rgba(245, 158, 66, 0.6)", // Orange shade
    //         borderColor: "rgba(245, 158, 66, 1)",
    //         borderWidth: 1,
    //       }],
    //     },
    //     options: {
    //       responsive: true,
    //       maintainAspectRatio: false,
    //       scales: { y: { beginAtZero: true, title: { display: true, text: "Number of Estates" } } },
    //       plugins: { legend: { position: "top" } },
    //     },
    //   });
    // }
  }, [data, searchTerm, PropertyTypes, priceRange, propertiesTypeFilter, loanTypeFilter, maxPage, dataLoading]);
  const resetPagination = () => {
    setPaginationRange({ min: 1, max: maxPage });
  }
  const resetLoanTypeFilters = () => {
    setLoanTypeFilter([]);
    setIsClearLoanFilter(true);
  }
  const hadnleSearchStats = async () => {
    let filter = {}
    if (searchColumn !== "") {
      if (searchColumn === "Key words") {
        filter = { "description": searchTerm }
      } else {
        filter = { [searchColumn]: searchTerm };
      }

    }

    filter.hasEmail=hasEmail;
    filter.minPrice = priceRange.min;
    filter.maxPrice = priceRange.max;
    filter.minEquity = equityRange.min * 100;
    filter.maxEquity = equityRange.max * 100;
    filter.minInterestRate = interestRange.min;
    filter.maxInterestRate = interestRange.max;
    filter.homeType = propertiesTypeFilter;
    filter.loanTypes = loanTypeFilter;
    const stats = await fetchStats(filter);
    console.log(stats);
    if (stats.totalCount === 0) {

    } else {
      setPropertiesFilter(filter);
      stats.averageInterestRate = parseFloat(stats.averageInterestRate.toFixed(2));
      const citiesDistrubtion = stats.cities.reduce((acc, row) => {
        const city = row.city || "Unknown";
        acc[city] = (acc[city] || 0) + row.count;
        return acc;
      }, {});
      stats.cities = citiesDistrubtion;
      stats.averagePrice = parseFloat(stats.averagePrice.toFixed(2))
      setData(stats)
      setMaxPage(Math.ceil(stats.totalCount));
      resetPagination();
    }


    return;
  }
  return (
    <div className="min-h-screen bg-gray-50">
      <SubscriptionHeader />
      <main className="pt-20 pb-6 px-4 sm:px-6 lg:px-8"> {/* Offset for fixed header */}
        <div className="w-full max-w-7xl mx-auto bg-white rounded-xl shadow-2xl p-8"> {/* Matches listings page assumption */}
          {data.totalCount > 0 && (
            <div className="bg-gradient-to-r from-blue-100 to-white p-6 rounded-lg shadow-lg mb-8 border-l-4 border-blue-600">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">Summary Statistics</h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-lg text-gray-700">
                <p className="bg-white p-3 rounded shadow-sm"><strong>Average Interest Rate:</strong> &nbsp; {data.averageInterestRate}</p>
                <p className="bg-white p-3 rounded shadow-sm"><strong>Total Estates:</strong> &nbsp; {data.totalCount}</p>
                <p className="bg-white p-3 rounded shadow-sm"><strong>Average Price:</strong> &nbsp; ${data.averagePrice}</p>
              </div>
            </div>
          )}


          <div className="mb-4 flex items-end space-x-2">
            <div className="flex-1">
              <label htmlFor="search" className="block text-sm font-medium text-gray-700 mb-1">
                Search Listings
              </label>
              <input
                type="text"
                id="search"
                value={searchTerm}
                onChange={handleSearchChange}
                placeholder="Search listings..."
                className="block w-full text-xs text-gray-700 border border-gray-300 rounded-md py-1 px-3 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
              />
            </div>
            <div className="w-28 relative" ref={priceDropdownRef}>
              <label htmlFor="price-filter" className="block text-sm font-medium text-gray-700 mb-1">
                Price Range
              </label>
              <button
                id="price-filter"
                onClick={() => setShowPriceDropdown(!showPriceDropdown)}
                className="block w-full text-xs text-gray-700 border border-gray-300 rounded-md py-1 px-3 bg-white text-left focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 truncate"
              >
                {`${formatPrice(priceRange.min)} - ${formatPrice(priceRange.max)}`}
              </button>
              {showPriceDropdown && (
                <div className="absolute z-10 mt-1 w-64 bg-white border border-gray-300 rounded-md shadow-lg p-4">
                  <div className="mb-2 text-xs font-semibold text-gray-700">
                    {`${formatPrice(priceRange.min)} - ${formatPrice(priceRange.max)}`}
                  </div>
                  <div className="relative h-4 mb-4">
                    <div className="absolute w-full h-1 bg-gray-200 rounded-lg top-1/2 transform -translate-y-1/2" />
                    <div
                      className="absolute h-1 bg-blue-200 rounded-lg top-1/2 transform -translate-y-1/2"
                      style={{
                        left: `${((priceRange.min - priceLimits.min) / (priceLimits.max - priceLimits.min)) * 100}%`,
                        width: `${((priceRange.max - priceRange.min) / (priceLimits.max - priceLimits.min)) * 100}%`,
                      }}
                    />
                    <input
                      type="range"
                      min={priceLimits.min}
                      max={priceLimits.max}
                      step={priceLimits.step}
                      value={priceRange.min}
                      onChange={(e) => handlePriceChange("min", e.target.value)}
                      className="absolute w-full h-4 bg-transparent appearance-none cursor-pointer"
                      style={{ zIndex: 2 }}
                    />
                    <input
                      type="range"
                      min={priceLimits.min}
                      max={priceLimits.max}
                      step={priceLimits.step}
                      value={priceRange.max}
                      onChange={(e) => handlePriceChange("max", e.target.value)}
                      className="absolute w-full h-4 bg-transparent appearance-none cursor-pointer"
                      style={{ zIndex: 2 }}
                    />
                    <style jsx>{`
                  input[type="range"] {
                    pointer-events: none;
                  }
                  input[type="range"]::-webkit-slider-thumb {
                    pointer-events: auto;
                    appearance: none;
                    width: 12px;
                    height: 12px;
                    background: #2563eb;
                    border-radius: 50%;
                    cursor: pointer;
                    box-shadow: 0 0 0 2px white, 0 0 0 4px rgba(37, 99, 235, 0.3);
                  }
                  input[type="range"]::-moz-range-thumb {
                    pointer-events: auto;
                    width: 12px;
                    height: 12px;
                    background: #2563eb;
                    border-radius: 50%;
                    cursor: pointer;
                    border: none;
                    box-shadow: 0 0 0 2px white, 0 0 0 4px rgba(37, 99, 235, 0.3);
                  }
                  input[type="range"]::-webkit-slider-runnable-track {
                    width: 100%;
                    height: 8px;
                    background: transparent;
                  }
                  input[type="range"]::-moz-range-track {
                    width: 100%;
                    height: 8px;
                    background: transparent;
                  }
                `}</style>
                  </div>
                  <button
                    onClick={resetPriceRange}
                    className="mt-3 w-full text-xs text-blue-700 hover:underline"
                  >
                    Reset to $10K - $1M
                  </button>
                </div>
              )}
            </div>
            <div className="w-28 relative" ref={advancedDropdownRef}>
              <label htmlFor="advanced-filter" className="block text-sm font-medium text-gray-700 mb-1">
                Advanced Options
              </label>
              <button
                id="advanced-filter"
                onClick={() => setShowAdvancedDropdown(!showAdvancedDropdown)}
                className="block w-full text-xs text-gray-700 border border-gray-300 rounded-md py-1 px-3 bg-white text-left focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 truncate"
              >
                Advanced Options
              </button>
              {showAdvancedDropdown && (
                <div className="absolute z-10 mt-1 w-64 bg-white border border-gray-300 rounded-md shadow-lg p-4">
                  <div className="mb-4">
                    <div className="text-xs font-semibold text-gray-700 mb-2">
                      Interest Rate: {formatInterestRate(interestRange.min)} - {formatInterestRate(interestRange.max)}
                    </div>
                    <div className="relative h-4 mb-4">
                      <div className="absolute w-full h-1 bg-gray-200 rounded-lg top-1/2 transform -translate-y-1/2" />
                      <div
                        className="absolute h-1 bg-blue-200 rounded-lg top-1/2 transform -translate-y-1/2"
                        style={{
                          left: `${((interestRange.min - interestLimits.min) / (interestLimits.max - interestLimits.min)) * 100}%`,
                          width: `${((interestRange.max - interestRange.min) / (interestLimits.max - interestLimits.min)) * 100}%`,
                        }}
                      />
                      <input
                        type="range"
                        min={interestLimits.min}
                        max={interestLimits.max}
                        step={interestLimits.step}
                        value={interestRange.min}
                        onChange={(e) => handleInterestChange("min", e.target.value)}
                        className="absolute w-full h-4 bg-transparent appearance-none cursor-pointer"
                        style={{ zIndex: 2 }}
                      />
                      <input
                        type="range"
                        min={interestLimits.min}
                        max={interestLimits.max}
                        step={interestLimits.step}
                        value={interestRange.max}
                        onChange={(e) => handleInterestChange("max", e.target.value)}
                        className="absolute w-full h-4 bg-transparent appearance-none cursor-pointer"
                        style={{ zIndex: 2 }}
                      />
                      <style jsx>{`
                    input[type="range"] {
                      pointer-events: none;
                    }
                    input[type="range"]::-webkit-slider-thumb {
                      pointer-events: auto;
                      appearance: none;
                      width: 12px;
                      height: 12px;
                      background: #2563eb;
                      border-radius: 50%;
                      cursor: pointer;
                      box-shadow: 0 0 0 2px white, 0 0 0 4px rgba(37, 99, 235, 0.3);
                    }
                    input[type="range"]::-moz-range-thumb {
                      pointer-events: auto;
                      width: 12px;
                      height: 12px;
                      background: #2563eb;
                      border-radius: 50%;
                      cursor: pointer;
                      border: none;
                      box-shadow: 0 0 0 2px white, 0 0 0 4px rgba(37, 99, 235, 0.3);
                    }
                    input[type="range"]::-webkit-slider-runnable-track {
                      width: 100%;
                      height: 8px;
                      background: transparent;
                    }
                    input[type="range"]::-moz-range-track {
                      width: 100%;
                      height: 8px;
                      background: transparent;
                    }
                  `}</style>
                    </div>
                  </div>
                  <div className="mb-4">
                    <div className="text-xs font-semibold text-gray-700 mb-2">
                      Equity Rate: {formatInterestRate(equityRange.min)} - {formatInterestRate(equityRange.max)}
                    </div>
                    <div className="relative h-4 mb-4">
                      <div className="absolute w-full h-1 bg-gray-200 rounded-lg top-1/2 transform -translate-y-1/2" />
                      <div
                        className="absolute h-1 bg-blue-200 rounded-lg top-1/2 transform -translate-y-1/2"
                        style={{
                          left: `${((equityRange.min - equityLimits.min) / (equityLimits.max - equityLimits.min)) * 100}%`,
                          width: `${((equityRange.max - equityRange.min) / (equityLimits.max - equityLimits.min)) * 100}%`,
                        }}
                      />
                      <input
                        type="range"
                        min={equityLimits.min}
                        max={equityLimits.max}
                        step={equityLimits.step}
                        value={equityRange.min}
                        onChange={(e) => handleEquityChange("min", e.target.value)}
                        className="absolute w-full h-4 bg-transparent appearance-none cursor-pointer"
                        style={{ zIndex: 2 }}
                      />
                      <input
                        type="range"
                        min={equityLimits.min}
                        max={equityLimits.max}
                        step={equityLimits.step}
                        value={equityRange.max}
                        onChange={(e) => handleEquityChange("max", e.target.value)}
                        className="absolute w-full h-4 bg-transparent appearance-none cursor-pointer"
                        style={{ zIndex: 2 }}
                      />
                      <style jsx>{`
                    input[type="range"] {
                      pointer-events: none;
                    }
                    input[type="range"]::-webkit-slider-thumb {
                      pointer-events: auto;
                      appearance: none;
                      width: 12px;
                      height: 12px;
                      background: #2563eb;
                      border-radius: 50%;
                      cursor: pointer;
                      box-shadow: 0 0 0 2px white, 0 0 0 4px rgba(37, 99, 235, 0.3);
                    }
                    input[type="range"]::-moz-range-thumb {
                      pointer-events: auto;
                      width: 12px;
                      height: 12px;
                      background: #2563eb;
                      border-radius: 50%;
                      cursor: pointer;
                      border: none;
                      box-shadow: 0 0 0 2px white, 0 0 0 4px rgba(37, 99, 235, 0.3);
                    }
                    input[type="range"]::-webkit-slider-runnable-track {
                      width: 100%;
                      height: 8px;
                      background: transparent;
                    }
                    input[type="range"]::-moz-range-track {
                      width: 100%;
                      height: 8px;
                      background: transparent;
                    }
                  `}</style>
                    </div>
                  </div>
                  <div className="mb-4">
                    <div className="text-xs font-semibold text-gray-700 mb-2">Property Type</div>

                    {PropertyTypes.map((type) => (
                      <label key={type} className="block text-xs text-gray-700 mb-1">
                        <input
                          type="checkbox"
                          name="PropertyType"
                          value={type}
                          checked={propertiesTypeFilter.includes(type)}
                          onChange={handlepropertiesTypeFilterChange}
                          className="mr-1 accent-blue-600"
                        />
                        {type}
                      </label>
                    ))}

                  </div>
                  <div className="mb-4">
                    <div className="text-xs font-semibold text-gray-700 mb-2">Loan Type</div>

                    {['FHA', 'New Conventional', 'VA'].map((type) => (
                      <label key={type} className="block text-xs text-gray-700 mb-1">
                        <input
                          type="checkbox"
                          name="loanType"
                          value={type}
                          checked={loanTypeFilter.includes(type)}
                          onChange={handleLoanTypeChange}
                          className="mr-1 accent-blue-600"
                        />
                        {type}
                      </label>
                    ))}

                  </div>
                  <div className="text-xs font-semibold text-gray-700 mb-2">Has Email</div>

                  <label className="block text-xs text-gray-700 mb-1">
                    <input
                      type="checkbox"
                      name="hasEmail"
                      checked={hasEmail} // boolean state: true if email exists
                      onChange={(e) => setHasEmail(e.target.checked)}
                      className="mr-1 accent-blue-600"
                    />
                    Yes
                  </label>
                  <button
                    onClick={resetAdvancedOptions}
                    className="w-full text-xs text-blue-700 hover:underline"
                  >
                    Reset Advanced Options
                  </button>
                </div>
              )}
            </div>

            <div className="w-40">
              <label htmlFor="search-column" className="block text-sm font-medium text-gray-700 mb-1">
                Search Column
              </label>
              <select
                id="search-column"
                value={searchColumn}
                onChange={handleColumnChange}
                className="block w-full text-xs text-gray-700 border border-gray-300 rounded-md py-1 px-3 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
              >
                <option value="All">All Columns</option>
                {displayColumn.map((col) => (
                  <option key={col} value={col}>
                    {col
                      .replace("hdpData.homeInfo.", "")
                      .replace("propstream_data.", "")
                      .replace(/([A-Z])/g, " $1")
                      .trim()
                      .replace("Zestimate", "Zestimate")
                      .replace("Price For H D P", "Price For HDP")
                      .replace("Rent Zestimate", "Rent Zestimate")
                      .replace("Tax Assessed Value", "Tax Assessed Value")
                      .replace("Agent Email", "Agent Email")
                      .replace("Apn Info", "APN Info")
                      .replace("Interest Rates", "Interest Rates")
                      .replace("Legal Description", "Legal Description")
                      .replace("Loan Balances", "Loan Balances")
                      .replace("Loan Payments", "Loan Payments")
                      .replace("Loan Types", "Loan Types")
                      .replace("Owner Name", "Owner Name")
                      .replace("Prop Stream Mail Found", "Prop Stream Mail Found")
                      .replace(/^./, (str) => str.toUpperCase())}
                  </option>
                ))}
              </select>
            </div>
            <div className="w-28 relative" ref={advancedDropdownRef}>
              <button
                id="advanced-filter-search"
                onClick={() => hadnleSearchStats()}
                className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 hover:scale-105 transition-transform"
              >
                Search
              </button>
            </div>
          </div>
          {data.totalCount > 0 ? (
            <div className="space-y-8">
              <div className="grid grid-cols-1 gap-6">
                <div className="bg-gray-50 p-4 rounded-lg shadow-md">
                  <h2 className="text-xl font-semibold text-gray-800 mb-4">Estates per City</h2>
                  <div className="h-96 w-full"> {/* Tall and wide */}
                    <canvas ref={cityChartRef}></canvas>
                  </div>
                </div>
              </div>

              <div className="flex flex-wrap items-end gap-4">
                <div className="w-64 relative" ref={paginationDropdownRef}>
                  <label htmlFor="pagination-filter" className="flex items-center gap-1 text-sm font-medium text-gray-700 mb-1">
                    Number of leads
                  </label>

                  <button
                    id="price-filter"
                    onClick={() => setShowPaginationDropdown(!showPaginationDropdown)}
                    className="block w-full text-xs text-gray-700 border border-gray-300 rounded-md py-1 px-3 bg-white text-left focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 truncate"
                  >
                    {`${paginationRange.max}`}
                  </button>
                  {showPaginationDropdown && (
                    <div className="absolute z-10 mt-1 w-64 bg-white border border-gray-300 rounded-md shadow-lg p-4">
                      <div className="mb-2 text-xs font-semibold text-gray-700">
                        {` ${paginationRange.max}`}
                      </div>
                      <div className="relative h-4 mb-4">
                        <div className="absolute w-full h-1 bg-gray-200 rounded-lg top-1/2 transform -translate-y-1/2" />
                        <div
                          className="absolute h-1 bg-blue-200 rounded-lg top-1/2 transform -translate-y-1/2"
                          style={{
                            left: `${((paginationRange.min - paginationLimits.min) / (maxPage - paginationLimits.min)) * 100}%`,
                            width: `${((paginationRange.max - paginationRange.min) / (maxPage - paginationLimits.min)) * 100}%`,
                          }}
                        />
                        {/* <input
                  type="range"
                  min={paginationLimits.min}
                  max={maxPage}
                  step={paginationLimits.step}
                  value={paginationRange.min}
                  onChange={(e) => handlePaginationChange("min", e.target.value)}
                  className="absolute w-full h-4 bg-transparent appearance-none cursor-pointer"
                  style={{ zIndex: 2 }}
                /> */}
                        <input
                          type="range"
                          min={paginationLimits.min}
                          max={maxPage}
                          step={paginationLimits.step}
                          value={paginationRange.max}
                          onChange={(e) => handlePaginationChange("max", e.target.value)}
                          className="absolute w-full h-4 bg-transparent appearance-none cursor-pointer"
                          style={{ zIndex: 2 }}
                        />
                        <style jsx>{`
                  input[type="range"] {
                    pointer-events: none;
                  }
                  input[type="range"]::-webkit-slider-thumb {
                    pointer-events: auto;
                    appearance: none;
                    width: 12px;
                    height: 12px;
                    background: #2563eb;
                    border-radius: 50%;
                    cursor: pointer;
                    box-shadow: 0 0 0 2px white, 0 0 0 4px rgba(37, 99, 235, 0.3);
                  }
                  input[type="range"]::-moz-range-thumb {
                    pointer-events: auto;
                    width: 12px;
                    height: 12px;
                    background: #2563eb;
                    border-radius: 50%;
                    cursor: pointer;
                    border: none;
                    box-shadow: 0 0 0 2px white, 0 0 0 4px rgba(37, 99, 235, 0.3);
                  }
                  input[type="range"]::-webkit-slider-runnable-track {
                    width: 100%;
                    height: 8px;
                    background: transparent;
                  }
                  input[type="range"]::-moz-range-track {
                    width: 100%;
                    height: 8px;
                    background: transparent;
                  }
                `}</style>
                      </div>
                      {/* <button
                onClick={resetPagination}
                className="mt-3 w-full text-xs text-blue-700 hover:underline"
              >
                Reset to 1 - {maxPage}
              </button> */}
                    </div>
                  )}
                </div>
                <button
                  onClick={handleExportCSV}
                  disabled={data.totalCount === 0}
                  className="px-6 py-3 rounded-lg font-semibold text-white bg-blue-600 hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors"
                >
                  Export to CSV
                </button>
              </div>
              {dataLoading && (
                <div
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    background: "transparent", // 👈 fully clear background
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 9999,
                    pointerEvents: "auto", // block clicks to background
                  }}
                >
                  <div
                    style={{
                      background: "#fff",
                      padding: "2rem 3rem",
                      borderRadius: "12px",
                      boxShadow: "0 0 20px rgba(0,0,0,0.2)",
                      fontSize: "1.2rem",
                      textAlign: "center",
                    }}
                  >
                    <div
                      style={{
                        border: "6px solid #f3f3f3",
                        borderTop: "6px solid #3498db",
                        borderRadius: "50%",
                        width: "50px",
                        height: "50px",
                        margin: "0 auto 15px",
                        animation: "spin 1s linear infinite",
                      }}
                    />
                    Exporting CSV... Please wait
                  </div>

                  <style>
                    {`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        body {
          overflow: hidden !important;
        }
      `}
                  </style>
                </div>
              )}

            </div>
          ) : (
            <p className="text-center text-gray-500 text-lg mt-8">
              Please upload a CSV file to view statistics.
            </p>
          )}
        </div>
      </main>
    </div>
  );
}

export default DataStatsPage;